import { gql } from "graphql-request";

const SERVER_DELETE_ABSENCE = gql`
  mutation SERVER_DeleteAbsence($id: ID!) {
  deleteAbsence(id: $id)
}
`;
export default SERVER_DELETE_ABSENCE;
